// extracted by mini-css-extract-plugin
export default {"background":"AgregarUsuario_background__Se-Qi","modal":"AgregarUsuario_modal__35h4D","hr":"AgregarUsuario_hr__f3HXr","form":"AgregarUsuario_form__5bmGD"};